import { UserModel } from './user.model';
import { LoginErrorEnum} from '../_enums/login-error.enum';


export class ConfirmPasswordModel {
    user: UserModel;
    hasError: boolean;
    errorID: LoginErrorEnum;
}


// WEBPACK FOOTER //
// ./src/app/_models/confirm-password.model.ts